import React, { useCallback } from 'react';
import propTypes from 'prop-types';
import { Button, Panel, PanelHeading, PanelBlock } from 'src/ui/mui-ui-kit';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const fileIcons = {
  doc: 'file-word',
  docx: 'file-word',
  pdf: 'file-pdf',
  jpg: 'file-image',
  jpeg: 'file-image',
  png: 'file-image',
  gif: 'file-image',
  unknown: 'file',
};

function getFileIcon(fileName) {
  const fileExtensionRegex = /\.([\w]+)\??/g;
  const result = fileExtensionRegex.exec(fileName);
  const extension = result[1] ? result[1].toLowerCase() : '';

  if (fileIcons[extension]) {
    return fileIcons[extension];
  }
  return fileIcons.unknown;
}

export function UiMultiFileUploader({
  label,
  required,
  hideAsterisk,
  value,
  name,
  id,
  onChange,
}) {
  const showAsterisk = required && !hideAsterisk;

  const onSelectFiles = useCallback(event => {
    onChange([...(value || []), ...Array.from(event.target.files)]);
    // eslint-disable-next-line no-param-reassign
    event.target.value = '';
  });

  return (
    <Panel className="ui-multi-file-uploader">
      <PanelHeading>
        {label}
        {showAsterisk && (
          <span className="icon is-small has-text-danger asterisk">
            <FontAwesomeIcon icon={['fas', 'asterisk']} size="xs" />
          </span>
        )}
      </PanelHeading>
      {(value || []).map(item => {
        let name = item.name || item.url;

        if (item.url) {
          const match = /\/([\w\d-.%+]+)\??$/.exec(name);
          if (match && match.length === 2) {
            name = match[1];
          }
        }

        return (
          <PanelBlock key={item.id || item.name}>
            <span className="panel-icon">
              <FontAwesomeIcon
                icon={['fal', getFileIcon(item.name || item.url)]}
              />
            </span>
            {item.url ? <a href={item.url}>{name}</a> : name}
            <Button
              isColor="text"
              isSize="small"
              onClick={() => onChange(value.filter(file => file !== item))}
            >
              <span className="icon is-small has-text-danger">
                <FontAwesomeIcon icon={['fal', 'times-circle']} size="lg" />
              </span>
            </Button>
          </PanelBlock>
        );
      })}
      <PanelBlock>
        <input
          type="file"
          name={name}
          id={id}
          multiple
          onInput={onSelectFiles}
        />
        <label htmlFor={id} className="button is-gradient-bright is-fullwidth">
          Add files
        </label>
      </PanelBlock>
    </Panel>
  );
}

UiMultiFileUploader.defaultProps = {
  required: false,
  hideAsterisk: false,
};

UiMultiFileUploader.propTypes = {
  label: propTypes.string.isRequired,
  name: propTypes.string.isRequired,
  id: propTypes.string.isRequired,
  required: propTypes.bool,
  hideAsterisk: propTypes.bool,
  value: propTypes.oneOfType([propTypes.string, propTypes.array]).isRequired,
  onChange: propTypes.func.isRequired,
};
